import React, { Component } from "react";
import {
  Segment,
  Step,
  Container
} from "semantic-ui-react";

import Validator from "validatorjs";
import set from "lodash/set";
import request from "../../utils/request";

import NonProfitInfo from "../../components/forms/non-profit/NonProfitInfo.js";
import ContactInfo from "../../components/forms/non-profit/ContactInfo.js";
import FoundationInfo from "../../components/forms/non-profit/FoundationInfo.js";
import ResponseMessage from "../../components/common/ResponseMessage";

const nonProfitProfile = () => {
  return {
    id: 0,
    address: "",
    name: "",
    last_name: "",
    title: "",
    email: "",
    phone_number: "",
    birthday: "",
    nonprofit_id: 0,
    fed_tax_id: "",
    is_deleted: 0,
    emg_email: "",
    emg_fax_number: "",
    emg_first_name: "",
    emg_last_name: "",
    emg_phone_number: "",
    emg_title: "",
    fax_number: "",
    information: "",
    pri_email: "",
    pri_fax_number: "",
    pri_first_name: "",
    pri_last_name: "",
    pri_phone_number: "",
    pri_title: ""
  };
};

const resetState = (cls) => {
  return {
    isMounted: false,
    isLoading: true,
    xhrStatus: "",
    xhrMessage: "",
    validation: new Validator({}, {}),
    nonprofitList: [
      {
        key: 0,
        text: "Select Non Profit",
        value: 0
      }
    ],
    nonProfitId: 0,
    profile: nonProfitProfile(),
    step: "non-profit-info",

    steps: [
      {
        key: "non-profit-info",
        title: "Non-profit Info",
        link: true,
        onClick: () => cls.handleStep("non-profit-info"),
        active: true
      },
      {
        key: "contact-info",
        title: "Contact Info",
        link: true,
        onClick: () => cls.handleStep("contact-info"),
        active: false
      },
      {
        key: "foundation-info",
        title: "Foundation Info",
        link: true,
        onClick: () => cls.handleStep("foundation-info"),
        active: false
      }
    ]
  };
};

class NonProfitForm extends Component {
  constructor(props) {
    super(props);
    this.rules = {};
    this.customMessages = {};
    this.state = resetState(this);
    let id = this.props.match.params.id ? this.props.match.params.id : 0;
    this.state.nonProfitId = id;
    this.handleChange = this.handleChange.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }
  componentDidMount = () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace('/non-profits');
      return;
    }
    this.setState({ isMounted: true }, this.fetchData);
  };
  componentWillUnmount = () => {
    this.setState(resetState(this));
  };
  fetchData = () => {
    let self = this;
    let promises = [];
    if (this.state.nonProfitId > 0) {
      promises.push(
        request.get(this, `api:/non-profit/${this.state.nonProfitId}`)
      );
    }
    Promise.all(promises).then(function (values) {
      if (values[0]) {
        self.setProfile(values[0]);
      }
      self.setState({ isLoading: false });
    });
  };
  handleChange = (e, { name, value }) => {
    let data = this.state.profile;
    set(data, name, value);
    this.setState({ profile: data });
  };
  handlePhoneNumber = e => {
    let { name, value } = e.target;
    value = value.replace(/\D/g, "");
    let data = this.state.profile;
    set(data, name, value);
    this.setState({ profile: data });
  }
  handleEditor = e => {
    let profile = { ...this.state.profile }
    profile.information = e.target.value;
    this.setState({ profile });
  };
  handleContent = e => {
    let name = e.target.dataset.key;
    let value = e.target.textContent;
    let data = this.state.profile;
    set(data, name, value);
    this.setState({ profile: data });
  };
  handleRules = (obj, msg = {}) => {
    this.rules = obj;
    this.customMessages = msg;
  };
  setNonprofitList = result => {
    if (!this.state.isMounted) return false;
    let nonprofitList = this.state.nonprofitList;
    result.map(
      (value, index) =>
        (nonprofitList[value.id] = {
          key: value.id,
          text: value.name,
          value: value.id
        })
    );
    this.setState({
      nonprofitList: nonprofitList,
      isLoading: this.state.nonProfitId === 0 ? false : true
    });
  };
  setProfile = result => {
    let profile = result;
    this.setState({
      profile: profile,
      isLoading: false
    });
  };
  handleSubmit = () => {
    let req;
    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    const { profile, steps } = this.state;
    if (profile.id > 0) {
      req = request.put(this, `api:/non-profit/${profile.id}`, profile);
    } else {
      req = request.post(this, "api:/non-profit", profile);
    }
    req.then(resp => {
      this.setState({
        xhrStatus: resp.success ? "success" : "error",
        xhrMessage: resp.message,
        isLoading: false
      });
      if (resp.success) {
        if (this.state.nonProfitId === 0) {
          let newSteps = steps;
          newSteps[2].active = false;
          newSteps[0].active = true;
          this.setState({ profile: nonProfitProfile(), step: "non-profit-info", steps: newSteps });
        }
        setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
      }
    })
  };
  handleStep = index => {
    const { steps, profile } = this.state;

    // code block for validation
    let validation = new Validator(profile, this.rules, this.customMessages);
    this.setState({ validation });
    if (validation.passes()) {
      if (index === "submit") {
        return this.handleSubmit();
      }
      steps.map((value, key) => {
        steps[key].active = false;
        if (value.key === index) steps[key].active = true;
        return steps[key];
      });

      // handle actual form submission here
      this.setState({
        step: index
      });
    }
  };
  showStep = step => {
    switch (step) {
      default:
        return (
          <NonProfitInfo
            handleStep={this.handleStep}
            handleChange={this.handleChange}
            profile={this.state.profile}
            setRules={this.handleRules}
            valid={this.state.validation}
            handlePhoneNumber={this.handlePhoneNumber}
          />
        );
      case "contact-info":
        return (
          <ContactInfo
            handleStep={this.handleStep}
            handleChange={this.handleChange}
            profile={this.state.profile}
            handlePhoneNumber={this.handlePhoneNumber}
          />
        );
      case "foundation-info":
        return (
          <FoundationInfo
            handleStep={this.handleStep}
            handleChange={this.handleEditor}
            profile={this.state.profile}
            handleSubmit={this.handleSubmit}
          />
        );
    }
  };
  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }
  render() {
    const {
      step,
      steps,
      isLoading,
      xhrStatus,
      xhrMessage
    } = this.state;
    return (
      <Container text as={Segment} basic loading={isLoading}>
        <Segment basic onBlur={this.handleDismissPortal}>
          <Step.Group fluid items={steps} />
          {this.showStep(step)}
        </Segment>
        <ResponseMessage status={xhrStatus} message={xhrMessage} />
      </Container>
    );
  }
}

export default NonProfitForm;
